import { useCortexDecoderContext } from '../compatibility'
import ScannerGridOverlay, {
  ReceivingScannerBoxOverlay,
} from './ScannerGridOverlay'
import React, { useEffect, useRef } from 'react'
import { Skeleton } from '@mui/material'

export function ScanbotVideo() {
  const { isActive, isEnabled, error } = useCortexDecoderContext()
  const showGridOverlay = isActive && isEnabled && !error

  return (
    <div
      id="scanbot-video-container"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: isEnabled ? 0 : -1,
      }}
    >
      {showGridOverlay && <ScannerGridOverlay />}
    </div>
  )
}

export function ScanbotReceivingVideo({
  width = '675px',
  height = '381px',
}: {
  width?: string
  height?: string
}) {
  const { isActive, isEnabled, error } = useCortexDecoderContext()
  const [shouldShowOverlay, setShouldShowOverlay] = React.useState(
    isActive && isEnabled && !error
  )
  const [overlayKey, setOverlayKey] = React.useState(Date.now())
  const containerRef = useRef<HTMLDivElement>(null)
  const [isLoading, setIsLoading] = React.useState(true)

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1200)
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    const isOverlayVisible = isActive && isEnabled && !error
    setShouldShowOverlay(isOverlayVisible)
    if (isOverlayVisible) {
      setOverlayKey(Date.now())
    }
  }, [isActive, isEnabled, error])

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      if (shouldShowOverlay) {
        setOverlayKey(Date.now())
      }
    })
    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
      })
    }
    return () => observer.disconnect()
  }, [shouldShowOverlay])

  return (
    <div
      id="scanbot-video-container"
      ref={containerRef}
      style={{
        position: 'relative',
        objectFit: 'cover',
        width,
        height,
        borderRadius: '12px',
        zIndex: isEnabled ? 0 : -1,
        overflow: 'hidden',
      }}
    >
      <Skeleton
        variant="rectangular"
        width="100%"
        height="100%"
        sx={{ position: 'absolute', inset: 0, borderRadius: '12px' }}
        animation="wave"
        aria-busy="true"
        aria-label="Loading video"
      />
      {!isLoading && shouldShowOverlay && (
        <ReceivingScannerBoxOverlay
          key={overlayKey}
          width={width}
          height={height}
        />
      )}
    </div>
  )
}
